import { typography as brandTypography } from '../brand2020/typography';
import { Typography } from '../types';

const newThemeValues = {
  fontFamilies: {
    primary: 'Source Sans Pro',
    secondary: 'Montserrat Alternates',
  },
  fontWeights: {
    bold: '700',
    regular: '400',
    semibold: '600',
  },
  lineHeights: {
    1: '20px',
    2: '24px',
    3: '28px',
    4: '36px',
    5: '40px',
    6: '48px',
    7: '60px',
    8: '76px',
  },
  fontSize: {
    1: '14px',
    2: '16px',
    3: '18px',
    4: '24px',
    5: '28px',
    6: '36px',
    7: '44px',
    8: '56px',
  },
};

export const typography: Typography = {
  ...brandTypography,
  borderFocusWidth: '2px',
  fontFamily: {
    primary: newThemeValues.fontFamilies.primary,
  },
  fontWeight: {
    normal: newThemeValues.fontWeights.regular,
    black: newThemeValues.fontWeights.semibold,
    bold: newThemeValues.fontWeights.bold,
  },
  body: {
    size: newThemeValues.fontSize['2'],
    weight: newThemeValues.fontWeights.regular,
    lineHeight: newThemeValues.lineHeights['2'],
    style: 'normal',
  },
  hyperlink: {
    size: newThemeValues.fontSize['2'],
    weight: newThemeValues.fontWeights.semibold,
    lineHeight: newThemeValues.lineHeights['2'],
  },
  label: {
    size: newThemeValues.fontSize['2'],
    weight: newThemeValues.fontWeights.semibold,
    lineHeight: newThemeValues.lineHeights['1'],
  },
};
